import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { ChangeATMPINMain } from './ChangeATMPINMain';
import { ChangeATMPINConfirm } from './ChangeATMPINConfirm';
import { ChangeATMPINPlaced } from './ChangeATMPINPlaced';

import { ChangeATMPINStackParamList, ChangeATMPINStackRoutes } from './type';

const ChangeATMPINStack = createNativeStackNavigator<ChangeATMPINStackParamList>();

export const ChangeATMPINNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.ChangeATMPIN>> = ({
  route
}) => {
  const { account, tab, record, func } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <ChangeATMPINStack.Navigator
          initialRouteName={ChangeATMPINStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <ChangeATMPINStack.Screen
            name={ChangeATMPINStackRoutes.Main}
            component={ChangeATMPINMain}
            initialParams={{ onLayout, onData, account, tab, record, func, onReturnData }}
            options={{ headerShown: false }}
          />
          <ChangeATMPINStack.Screen
            name={ChangeATMPINStackRoutes.Confirm}
            component={ChangeATMPINConfirm}
            initialParams={{ onLayout, data, account, tab, record, func, onReturnData }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <ChangeATMPINStack.Screen
            name={ChangeATMPINStackRoutes.Placed}
            component={ChangeATMPINPlaced}
            initialParams={{ onLayout, data, account, tab, returnData }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </ChangeATMPINStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
